<template>
    <div class="person-list-container">
        <div v-if="nbElements === 0" class="fs-2 gray-60" @click="toggleList">
            {{ listPlaceholder }}
        </div>

        <CompassLink
            v-else-if="nbElements > 1"
            type="secondary"
            :label="`${nbElements} ${listPlaceholder}`"
            size="small"
            @click="toggleList"
        ></CompassLink>
        <div v-else class="flex-level">
            <person-light :person="list[0]" :label="personPlaceholder"></person-light>
        </div>

        <div
            v-if="displayList"
            class="person-list pabsolute zi-1000 top-left well p-0 span_12 shadow b-0 ellipsis top-3 br mt-4 ml-4"
            @click="toggleList"
            @mouseleave="toggleList"
        >
            <ul class="person m-0 mxh-200 ovy-auto">
                <li v-for="person in list" :key="person.id" class="px-3 py-2 cpointer copy-element">
                    <person-light :person="person" :label="personPlaceholder"></person-light>
                </li>
            </ul>
        </div>
    </div>
</template>
<script>
import AvatarMixins from 'mixins/AvatarMixins';
import PersonLight from './PersonLight.vue';

export default {
    components: {
        PersonLight,
    },
    mixins: [AvatarMixins],
    props: {
        list: {
            type: Array,
            required: true,
        },
        placeholder: {
            type: String,
            default: '',
            required: false,
        },
        placeholderPlural: {
            type: String,
            default: '',
            required: false,
        },
        placeholderSingular: {
            type: String,
            default: '',
            required: false,
        },
        // Used in mixin
        // eslint-disable-next-line vue/no-unused-properties
        size: {
            type: String,
            required: false,
            default: '',
        },
    },

    data() {
        return {
            displayList: false,
        };
    },
    computed: {
        nbElements() {
            return Array.isArray(this.list) ? this.list.length : Object.keys(this.list).length;
        },
        listPlaceholder() {
            if (this.placeholderPlural.length) {
                return this.$l10n.__(this.placeholderPlural);
            }
            return this.placeholder.length
                ? this.$l10n.__(this.placeholder)
                : this.$l10n.__('Collaborateurs');
        },
        personPlaceholder() {
            if (this.placeholderSingular.length) {
                return this.$l10n.__(this.placeholderSingular);
            }
            return this.placeholder.length
                ? this.$l10n.__(this.placeholder)
                : this.$l10n.__('Collaborateur');
        },
    },
    methods: {
        toggleList() {
            if (this.nbElements > 1) {
                this.displayList = !this.displayList;
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@import '~@sellsy/styleguide/src/_variables';

.person-list {
    width: auto;
    min-width: 200px;
}

.person-list ul.person li:hover {
    background-color: $primary-05;
    .person-name {
        color: $primary-50;
    }
}

.person {
    display: flex;
    flex-direction: column;
    overflow-x: hidden;
    .fullname {
        width: calc(100% - 40px);
        padding-left: 8px;
    }
}
.person-name {
    width: calc(100% - 45px);
}

.cd-timeline-block {
    .person-list {
        width: auto !important;
    }
}
</style>
